// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { cn } from "@/lib/utils"

interface CheckboxProps {
  id: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  className?: string
}

/**
 * Plain native checkbox (no Radix primitive is installed for this
 * component set — see frontend/package.json, which this task does not
 * touch) styled to match the rest of the onboarding form controls.
 */
export function Checkbox({ id, checked, onCheckedChange, className }: CheckboxProps) {
  return (
    <input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={e => onCheckedChange(e.target.checked)}
      className={cn(
        "mt-0.5 size-5 shrink-0 rounded border-line text-green focus-visible:ring-2 focus-visible:ring-green",
        className
      )}
    />
  )
}
